import React from "react";
import "./Events.scss";
import vid from "../GSC-Event.webm";
import NavBar from "../Nav_Footer/NavBar";
import Footer from "../Nav_Footer/Footer";
import useFadeIn from "../hooks/useFadeIn";

function EventCard({ label, title, children, index = 0 }) {
  const ref = useFadeIn(index * 100);
  return (
    <div ref={ref} className="event-card fade-in">
      <div className="event-card-body">
        <span className="event-card-accent" />
        <span className="section-label">{label}</span>
        <h2>{title}</h2>
        <p>{children}</p>
      </div>
    </div>
  );
}

const EventsPage = () => {
  const introRef = useFadeIn();
  const typesLabelRef = useFadeIn();
  const ctaRef = useFadeIn();

  return (
    <>
      <NavBar />
      <div className="events-page">

        {/* Hero */}
        <div className="events-hero">
          <video src={vid} autoPlay muted loop className="events-hero-video" />
          <div className="events-hero-overlay">
            <span className="section-label">El Gouna Sailing Club</span>
            <h1>Events &amp; Private Gatherings</h1>
            <p>
              A setting unlike any other, where the Red Sea becomes the
              backdrop to your most memorable occasions.
            </p>
          </div>
        </div>

        {/* Intro: full-bleed band, same pattern as Home */}
        <section ref={introRef} className="events-intro fade-in">
          <p>
            At El Gouna Sailing Club, we host events that draw their energy
            from the water. Whether intimate or grand, onshore or offshore,
            every occasion we produce carries the spirit of the sea:
            unhurried, open, and impossible to replicate elsewhere.
          </p>
        </section>

        {/* Event types label: same "intro" eyebrow pattern as Home */}
        <div ref={typesLabelRef} className="intro fade-in">
          <h2>Event Types</h2>
          <p>Find the right setting for your occasion</p>
        </div>

        {/* Event types: uniform cards, two per row */}
        <div className="events-grid">
          <div className="events-grid-inner">
            <EventCard label="Ceremonies" title="Weddings" index={0}>
              Say your vows with the Red Sea as witness. From intimate
              beachside ceremonies to grand evening receptions, we provide
              the space, the setting, and the coordination to bring your
              vision to life.
            </EventCard>

            <EventCard label="Professional" title="Corporate Events &amp; Dinners" index={1}>
              Host your next corporate dinner, team retreat, or gala in a
              venue that offers far more than a conference room ever could.
            </EventCard>

            <EventCard label="On the Water" title="Offshore &amp; Onboard Events" index={2}>
              Private yacht dinners, floating gatherings, and open-water
              celebrations tailored to your group. The sea is the venue.
            </EventCard>

            <EventCard label="Celebrations" title="Private Parties &amp; Milestones" index={3}>
              Birthdays, anniversaries, reunions: flexible spaces arranged
              for dining, dancing, or simply being together by the water.
            </EventCard>
          </div>
        </div>

        {/* CTA: full-bleed band, same pattern as Home */}
        <section ref={ctaRef} className="events-cta fade-in">
          <span className="section-label">Get in Touch</span>
          <h2>Plan Your Event With Us</h2>
          <p>
            Every event begins with a conversation. Reach out to our team
            and we will work with you to design an experience that fits your
            occasion, your group, and the spirit of El Gouna.
          </p>
          <a
            href="https://www.instagram.com/elgounasailingclub?igsh=MWNyYThpbzl0d3VhZQ%3D%3D&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="events-contact-btn"
          >
            Contact Us on Instagram
          </a>
        </section>

      </div>
      <Footer />
    </>
  );
};

export default EventsPage;
